import React, { useContext } from "react";
import { Styles } from "./Participants.styles";
import { Col, Row } from "react-bootstrap";
import { SocketContext } from "../../context/SocketContext";
import { onBanStudent } from "../../utils/Alert";

const Participants = ({ isTeacher = false }) => {
  const { participants } = useContext(SocketContext);

  return (
    <Styles>
      <Col>
        {participants.teacher && <Participant user={participants.teacher} />}
        {participants.students?.map((user) => (
          <Participant key={user.email} bannable={isTeacher} user={user} />
        ))}
      </Col>
    </Styles>
  );
};

const Participant = ({ bannable = false, user }) => {
  const { sendSocketEvent } = useContext(SocketContext);

  const onBan = (email) => {
    sendSocketEvent("teacher/ban", { studentEmail: email });
  };

  return (
    <Row className="px-2 py-1">
      <div className="d-flex flex-row justify-content-between">
        <div className="d-flex flex-row">
          <i className="icon-avatar fas fa-user p-2 me-1" />
          <span>
            {user.firstName} {user.lastName}
          </span>
        </div>
        {bannable && <i className="icon-button fas fs-5 fa-ban" onClick={() => onBanStudent(user, onBan)} />}
      </div>
    </Row>
  );
};

export default Participants;
